export default __webpack_public_path__ + "static/attribute_do-5cae2a3340914bb4e2dc76324a49ddb1.png";